export const IOS_PRIVATE_MODE = 'iso_private_mode';
export const TABLE_BOOKING_SUCCESS = 'table_Booking_success';
export const MEAL_PICTURE = 'meal_picture';
export const ALLERGY = 'allergy';
export const VOUCHER = 'voucher';
export const DISABLED_MEAL = 'disabled_meal';
export const FEEDBACK_FULFILLMENT_ERROR = 'feedback_fulfillment_error';



// WEBPACK FOOTER //
// ./constants/modalType.js